/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AiAgentV2ControllerSubmitOnboardingSkillMutationRequest, AiAgentV2ControllerSubmitOnboardingSkillMutationResponse, AiAgentV2ControllerSubmitOnboardingSkill400, AiAgentV2ControllerSubmitOnboardingSkill401, AiAgentV2ControllerSubmitOnboardingSkill403, AiAgentV2ControllerSubmitOnboardingSkill404 } from "../../models/aiAgentV2Controller/AiAgentV2ControllerSubmitOnboardingSkill";

function getAiAgentV2ControllerSubmitOnboardingSkillUrl() {
  const res = { method: 'POST', url: `/api/v1/ai-agent-v2/onboarding-query` as const }  
  return res
}

/**
 * @summary Submit or reconcile a selected onboarding skill
 * {@link /api/v1/ai-agent-v2/onboarding-query}
 */
export async function aiAgentV2ControllerSubmitOnboardingSkill(data: AiAgentV2ControllerSubmitOnboardingSkillMutationRequest, config: Partial<RequestConfig<AiAgentV2ControllerSubmitOnboardingSkillMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<AiAgentV2ControllerSubmitOnboardingSkillMutationResponse, ResponseErrorConfig<AiAgentV2ControllerSubmitOnboardingSkill400 | AiAgentV2ControllerSubmitOnboardingSkill401 | AiAgentV2ControllerSubmitOnboardingSkill403 | AiAgentV2ControllerSubmitOnboardingSkill404>, AiAgentV2ControllerSubmitOnboardingSkillMutationRequest>({ method : "POST", url : getAiAgentV2ControllerSubmitOnboardingSkillUrl().url.toString(), data : requestData, ... requestConfig })  
  return res.data
}